<template>
  <b-modal
    id="create-bank-account"
    :modal-class="modalClasses"
    :hide-footer="true"
    @hidden="hidden"
    @shown="shown"
  >
    <template v-slot:modal-title>
      Criar conta bancária
    </template>

    <template v-slot:default>

      <BankAccountCreationForm
        @bank-account-created="parseCreatedAccount"
      />
    </template>
  </b-modal>
</template>

<script>

import BankAccountCreationForm from '@/components/bank-accounts/BankAccountCreationForm'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { mapState } from 'vuex'

export default {
  name: 'BankAccountCreationModal',
  components: {
    BankAccountCreationForm
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    }
  },
  methods: {
    shown () {
    },
    hidden () {
      this.reset()
    },
    reset () {
    },
    parseCreatedAccount (e) {
      this.$bvModal.hide('create-bank-account')
      const notification = {
        notification: {
          type: 'success',
          content: 'Conta bancária criada com sucesso'
        }
      }
      NotificationService.createGlobalSuccessNotification(notification)
      this.$emit('bank-account-created', e)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
